import { forwardTo, getReturnUrlFromRequestLoader } from 'utils/common/route';

export const blankLoader = ({ request }) => {
  const returnUrl = getReturnUrlFromRequestLoader(request) || '/';

  forwardTo(returnUrl);
  return null;
};
